import { isDev } from '../src/utils';

const baseUrl = isDev ? '' : '/api';

const getEndpoint = (route) => `${baseUrl}${route}`;

export default getEndpoint;
